import React from 'react';
import { useAuth } from 'react-oidc-context';
import { NavBar } from './components/NavBar';
import Home from './pages/Home';
import { useEffect } from 'react';

export default function App() {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const url = new URL(window.location.href);
      if (url.search) {
        window.history.replaceState({}, document.title, url.pathname);
      }
    }
  }, [auth.isAuthenticated]);
  
  useEffect(() => {
    const checkTokenExpiry = () => {
      const expiresAt = auth.user?.expires_at;
      if (expiresAt && Date.now() / 1000 > expiresAt) {
        console.warn('🔐 Access token expired. Logging user out.');
        auth.removeUser();
        window.location.href = '/';
      }
    };
  
    const interval = setInterval(checkTokenExpiry, 30 * 1000);
    return () => clearInterval(interval);
  }, [auth]);
  
  if (auth.activeNavigator === 'signinSilent' || auth.isLoading) {
    return <div style={{ textAlign: 'center', marginTop: '5rem' }}>Loading...</div>;
  }

  if (auth.error) {
    const errorMessage = auth.error.message.includes("No matching state")
      ? "Your session was interrupted or expired. Please log in again."
      : auth.error.message;

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        padding: '2rem',
        color: '#712B1F',
        textAlign: 'center'
      }}>
        <h2>⚠️ Authentication Error</h2>
        <p>{errorMessage || "Something went wrong during authentication."}</p>
        <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '0.6rem 1.2rem',
              backgroundColor: '#f59e0b',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Retry
          </button>
          <button
            onClick={() => void auth.signinRedirect()}
            style={{
              padding: '0.6rem 1.2rem',
              backgroundColor: '#712B1F',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Login Again
          </button>
        </div>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        padding: '2rem',
        textAlign: 'center',
        color: '#712B1F'
      }}>
        <h2>🔒 Please log in to continue</h2>
        <button
          onClick={() => auth.signinRedirect()}
          style={{
            marginTop: '1rem',
            padding: '0.6rem 1.2rem',
            backgroundColor: '#712B1F',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Login
        </button>
      </div>
    );
  }

  return (
    <div>
      <NavBar />
      <Home />
    </div>
  );
}
